








































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import Toast from '@/app/components/Common/Toast.vue'
import AccountSearch from '@/app/components/Account/AccountSearch.vue'
import RowHeader from '@/app/components/Account/RowHeader.vue'
import AccountList from '@/app/components/Account/AccountList.vue'
/* api */
import AccountListApi from '@/app/model/api/accountListApi'
/* module */
import Session from '@/app/module/session'
import CommonClass from '@/app/module/common'
import { routerPath, userType } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    Loading,
    Toast,
    AccountSearch,
    RowHeader,
    AccountList
  }
})
export default class Account extends Vue {
  private isOkAccountList: boolean = false
  private isOkFieldList: boolean = false
  private defaultAccountData: any[] = []
  private accountData: any = this.$store.state.accountState.accountData
  private notDataMessage: boolean = false
  private showList: boolean = false
  private showAccountLoading: boolean = true
  private showErrorAlert: boolean = false
  private showCompleteAlert: boolean = false
  private alertText: string = ''
  private alertMessage: string = this.$store.state.alertState.message

  created () {
    this.getData()
  }

  private async getData () {
    this.showAccountLoading = true
    let search: any = this.$refs.search
    let searchList: any = this.$refs.searchList
    if (search !== undefined && searchList !== undefined) {
      search.requesting = true
      searchList.requesting = true
    }

    const data = {
      userType: this.$store.state.accountState.choiceAccountType,
      word: this.$store.state.accountState.searchText,
      orderNum: this.$store.state.accountState.orderNum,
      sort: this.$store.state.accountState.sort
    }

    const result = await AccountListApi.getAccountList(data)
    this.$store.commit('routeState/setRoute', this.$route.path)

    if (result.isOk()) {
      this.updateList(result.getPayload())
      this.defaultAccountData = result.getPayload()
      this.showAccountLoading = false
    } else if (result.checkTimeoutErrorStatus()) {
      this.$store.commit('routeState/setTimeoutErrorFlag', true)
      this.$store.commit('routeState/setErrorFlag', false)
      this.$router.push(routerPath.PATH_ERROR_PAGE)
    } else if (result.checkErrorStatus()) {
      this.$store.commit('routeState/setErrorFlag', true)
      this.$router.push(routerPath.PATH_ERROR_PAGE)
    } else if (result.checkNotFoundStatus()) {
      this.$store.commit('routeState/setErrorFlag', false)
      this.$router.push(routerPath.PATH_ERROR_PAGE)
    } else if (result.checkStatus()) {
      CommonClass.doLogout()
    } else {
      this.showAccountLoading = false
      this.showErrorAlert = true
      this.alertText = result.getPayload().message
    }

    let flag = this.$store.state.alertState.alertFlag
    if (flag) {
      this.showCompleteAlert = flag
    }

    if (search !== undefined && searchList !== undefined) {
      search.requesting = false
      searchList.requesting = false
    }
  }

  private updateList (val: any) {
    this.$store.commit('accountState/setAccountList', val)
    this.accountData = this.$store.state.accountState.accountData

    if (this.accountData.length === 0) {
      this.notDataMessage = true
    } else {
      this.notDataMessage = false
    }

    this.showAccountLoading = false
    this.showList = true
  }

  private doAccountSort () {
    this.$store.commit('accountState/setOrderNum', 1)

    if (this.$store.state.accountState.sort === 'asc') {
      this.$store.commit('accountState/setSort', 'desc')
    } else {
      this.$store.commit('accountState/setSort', 'asc')
    }
    this.getData()
  }

  private closeAlert () {
    this.showCompleteAlert = false
    this.$store.commit('alertState/setAlertFlag', false)
  }
}
